import React, { Component } from "react";
import { Header, Segment } from "semantic-ui-react";
import { baseUrl } from "../../utils/constants";

class HelpJackpot extends Component {
  render() {
    return (
      <Segment basic>
        <Header as="h2">
          <Header.Subheader>
            This is the link to your jackpot display page for kiosks, some
            scoreboards, and etc.
          </Header.Subheader>
          <a href={baseUrl + "/jackpot"} target="_blank" rel="noopener noreferrer">
            {baseUrl + "/jackpot"}
          </a>
        </Header>
      </Segment>
    );
  }
}

export default HelpJackpot;
